import script from "./PromoCodeView.vue?vue&type=script&setup=true&lang=ts"
export * from "./PromoCodeView.vue?vue&type=script&setup=true&lang=ts"

import "./PromoCodeView.vue?vue&type=style&index=0&id=17a3ca9f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17a3ca9f"]])

export default __exports__